export default "__VITE_ASSET__DbIMyEKG__"